module.exports = __webpack_public_path__ + "static/media/house-crown.57a887cf.png";